export const sliderSettings = {
  // dots + arrows give a "more cards" cue (5 cards, 3 visible). Styled minimally
  // in Cards.styles.ts so they read over the map without clutter.
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  swipeToSlide: true,
  draggable: true,
  touchThreshold: 10,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};
